import * as React from 'react';
import { createRoot } from 'react-dom/client';
import type { NonInteractiveContinueHandlerType, NonInteractiveRenderViewReturnType, RenderViewPropsType, RenderViewReturnType } from '../types';
import { ContractorSearchInterface } from '../../../React/features/Chat/features/ContractorSearchInterface';
import { UserAnswersType } from '../../types';

export const COMPONENT_IDENTIFIER = 'contractor-search-interface';
const COMPONENT_ROOT_CLASS_NAME = `chat-${COMPONENT_IDENTIFIER}-container`;

export type RenderContractorSearchInterfacePropsType = RenderViewPropsType<{
  userAnswers: UserAnswersType;
  commonAnswerHandler: (paramName: string, answerText: string) => void;
}>

export const renderContractorSearchInterface = async (props: RenderContractorSearchInterfacePropsType): RenderViewReturnType<NonInteractiveRenderViewReturnType> => {
  const { chatRoot, keyName } = props;

  // レンダーするためのルート要素を作成
  const viewContainer = document.createElement('div');
  const viewRoot = createRoot(viewContainer);

  // コンテナ要素にクラス付与
  viewContainer.classList.add(COMPONENT_ROOT_CLASS_NAME);
  viewContainer.classList.add(keyName);

  // チャットルートにコンテナ要素をappendする
  chatRoot.appendChild(viewContainer);

  return new Promise((resolve) => {
    const continueHandler = (args: NonInteractiveContinueHandlerType) => resolve({ ...args, viewRootDomReference: viewContainer });

    // appendしたコンテナ要素にJsxをレンダリングする
    viewRoot.render(<ContractorSearchInterface {...props} continueHandler={continueHandler} />);
  });
};
